export enum FormPurpose {
  'PURCHASE' = 'PURCHASE',
  'BUILD' = 'BUILD',
  'RENOVATION' = 'RENOVATION',
  'MORTGAGE' = 'MORTGAGE',
  'CONSOLIDATION' = 'CONSOLIDATION',
  'REFINANCING' = 'REFINANCING',
}
